import csrfToken from 'system/csrfToken';
// eslint-disable-next-line import/no-unresolved
import util from 'utils/util';

import RPC from 'RPC';

import { SDKLogger } from './SDKLogger';

const originalRpcCall = RPC.call;

// TODO: check all apis work
RPC.setup('emulateHTTP', false);

RPC.call = function rpcCallInject(method, data, options = {}) {
    // dataType is overwritten in RPC.call, need to avoid it
    options._dataType = options.dataType || 'json';

    // don't use embedded RPC's request id header, as we use our own
    options.withoutRequestId = true;

    const type = options.type;

    const shouldAddDefaultJsonHandling =
        !options.contentType && type && type.toLowerCase() !== 'get';

    if (shouldAddDefaultJsonHandling) {
        options.contentType = 'application/json';
        options.processData = false;
    }

    options.beforeSend = function beforeSend(xhr, settings) {
        const token = csrfToken.get('token');

        if (token) {
            xhr.setRequestHeader('x-csrf-token', token);
        }

        xhr.setRequestHeader('Cache-Control', 'no-cache');

        if (shouldAddDefaultJsonHandling) {
            settings.data = JSON.stringify(settings.data);
        }
    };

    return _callWithLogging({
        rpcInstance: this,
        method,
        data,
        options,
    });
};

function _callWithLogging({ rpcInstance, method, data, options }) {
    const requestLogger = SDKLogger.createSingleRequestLogger({
        group: 'api',
        type: options.type,
        method,
        logResponseTextOnError: true,
        backendType: 'RPC',
    });

    options.headers = {
        ...options.headers,
        ...requestLogger.getLoggingHeaders(),
    };

    const originalResult = originalRpcCall.call(
        rpcInstance,
        method,
        data,
        options,
    );

    originalResult.then(_logOnResponse, _logOnResponse);

    return originalResult;

    function _logOnResponse(xhr) {
        requestLogger.logXhrOnResponse({
            xhr,
            customData: {
                aborted: xhr.aborted,
            },
        });
    }
}

// dataType is overwritten in RPC.call, need to avoid it
const send = RPC.Request.prototype.send;
RPC.Request.prototype.send = function(options) {
    options.dataType = options._dataType;

    return send.call(this, options);
};
// eslint-disable-next-line
RPC.Request.prototype.end = function rpcRequestEndInject(error, response) {
    // сохраняем реальный статус
    this.httpStatus = this.status;

    const xhr = this.xhr;
    const contentType = xhr.getResponseHeader('Content-Type');

    this.status = xhr.status;

    if (error) {
        try {
            response = JSON.parse(xhr.responseText);
        } catch (reason) {
            response = undefined;
        }
    }

    const specialHeader = xhr.getResponseHeader('X-Server') == null;

    if (response && specialHeader) {
        if (!response.status || !('body' in response)) {
            response = {
                status: xhr.status,
                body: response,
            };
        }

        // Всё ок, response ответило корретно, никаких http ошибок
        for (const key in response) {
            if (response.hasOwnProperty(key)) {
                this[util.toCamelCase(key)] = response[key];
            }
        }

        this.status = response.status * 1;
        this.statusName = RPC.codes[response.status];

        error = error || !this.isOK();
        response = response.body;
    } else if (specialHeader && contentType) {
        const matches = contentType.match(/^([a-zA-Z-]+\/[a-zA-Z-]+)?($|;.+$)/);

        if (matches && matches[1] === 'text/html') {
            error = error || !this.isOK();
            response = {
                responseText: xhr.responseText,
                response: xhr.response,
                contentType,
            };
        } else {
            error = error || true;
        }
    }

    reloadIfBlocked(response, this);

    return RPC.request.Request.fn.end.call(this, error, response);
};

function reloadIfBlocked(response, data) {
    const isAuthorised = data && data.url !== '/api/v1/auth/signin';
    const isDisabled =
        response &&
        response.error === 'ACCESS_DENIED' &&
        ['Project disabled', 'User disabled'].includes(response.message);

    if (isAuthorised && isDisabled) {
        window.location.reload();
    }
}
